export default function HorizontalCardList({ children }) {
  return (
    <div className="container">
      <h2 className="text-lg capitalize font-medium pb-2">Upcoming Lessons</h2>
      <div className="columns-5 pb-4">{children}</div>
    </div>
  );
}
